// extracted by mini-css-extract-plugin
export default {"root":"VolumeButton_root__osa7O","icon":"VolumeButton_icon__4aW6K","iconMuted":"VolumeButton_iconMuted__Fgd9i"};